export interface CreditReportFetchRequest {
    userId?: string;
    name: string;
    dob: string;
    gender?: string;
    address: string;
    city?: string;
    state: string;
    postal: string;
    phoneNumber: string;
    panNumber: string;
    owner?: CreditReportOwner;
    finl: string;
    loanAmount?: number;
}

export interface CreditReportFetchResponse {
    id: string;
    userId: string;
    panNumber: string;
    creditReport?: string;
    source: CreditBureauName;
    score: string;
    isNotDated: boolean;
    createdAt: Date;
    owner?: CreditReportOwner;
    createdBy?: string;
    fileContent?: string;
    fileName?: string;
    creditBureauUniqueReferenceId?: string;
}

export enum CreditBureauName {
    Equifax = 'Equifax',
    CIBIL = 'CIBIL',
}

export enum CreditReportOwner {
    BIZ = 'BIZ', 
    CUSTOMER = 'CUSTOMER'
}